import { Injectable } from '@angular/core';
import { AppNavV2 } from 'src/app/shared/models/app-nav-v2.model';
import { ProductAppCodes, ProductAppImagePrefix } from '../product-info/product-info.service';

@Injectable({
  providedIn: 'root'
})
export class AppNavV2ReportService {

  private readonly ReportSortOrder = [
    ProductAppCodes.StarReading,
    ProductAppCodes.StarReadingSpanish,
    ProductAppCodes.StarMath,
    ProductAppCodes.StarMathSpanish,
    ProductAppCodes.StarEarlyLiteracy,
    ProductAppCodes.StarEarlyLiteracySpanish,
    ProductAppCodes.StarCbmReading,
    ProductAppCodes.StarCbmLectura,
    ProductAppCodes.StarCbmMath,
    ProductAppCodes.StarPhonics,
    ProductAppCodes.FastBridge,
    ProductAppCodes.AR,
    ProductAppCodes.Freckle,
    ProductAppCodes.Myon,
    ProductAppCodes.Lalilo,
    ProductAppCodes.DataSharingReports,
    ProductAppCodes.CustomReports
  ]

  constructor() { }

  public addImagePrefixes(reportItems: AppNavV2[]): AppNavV2[] {
    for (let appNavItem of reportItems) {
      if (this.isImagePrefixRequired(appNavItem.appCode)) {
        appNavItem.imagePrefix = this.getImagePrefixByAppCode(appNavItem.appCode);
      }
    }

    return reportItems;
  }

  public sortReports(reportItems:AppNavV2[]): AppNavV2[] {
    return reportItems.sort((a, b) => {
      const indexA = this.ReportSortOrder.indexOf(a.appCode);
      const indexB = this.ReportSortOrder.indexOf(b.appCode);
      return indexA - indexB;
    });
  }

  private isImagePrefixRequired(appCode: string): boolean {
    let isImagePrefixRequired = true;
    switch (appCode) {
      case ProductAppCodes.AdminReports:
      case ProductAppCodes.MyCreatedReports:
      case ProductAppCodes.DataSharingReports:
      case ProductAppCodes.CustomReports:
        isImagePrefixRequired = false;
        break;
    }
    return isImagePrefixRequired
  }
  private getImagePrefixByAppCode(appCode: string): string {
    let imagePrefix = "";
    switch (appCode) {
      case ProductAppCodes.StarReading:
      case ProductAppCodes.StarMath:
      case ProductAppCodes.StarEarlyLiteracy:
      case ProductAppCodes.StarReadingSpanish:
      case ProductAppCodes.StarMathSpanish:
      case ProductAppCodes.StarEarlyLiteracySpanish:
      case ProductAppCodes.StarCbmMath:
      case ProductAppCodes.StarCbmReading:
      case ProductAppCodes.StarCbmLectura:
      case ProductAppCodes.StarPhonics:
        imagePrefix = ProductAppImagePrefix.Star;
        break;
      case ProductAppCodes.AR:
        imagePrefix = ProductAppImagePrefix.AR;
        break;
      case ProductAppCodes.Myon:
        imagePrefix = ProductAppImagePrefix.Myon;
        break;
      case ProductAppCodes.FastBridge:
        imagePrefix = ProductAppImagePrefix.Fastbridge;
        break;
      case ProductAppCodes.Freckle:
        imagePrefix = ProductAppImagePrefix.Freckle;
        break;
      case ProductAppCodes.Lalilo:
        imagePrefix = ProductAppImagePrefix.Lalilo;
        break;
    }
    return imagePrefix;
  }
}
